export default "__VITE_ASSET__1c7dc7f4__"